// extracted by mini-css-extract-plugin
export var block = "block-module--block--gTrDA";
export var head = "block-module--head--9o_z1";
export var contentWrap = "block-module--contentWrap--30d-y";
export var title = "block-module--title--1tJXh";
export var subtitle = "block-module--subtitle--15xFL";
export var button = "block-module--button--dbmu8";
export var contentWrapItem = "block-module--contentWrapItem--28Gx5";
export var content = "block-module--content--xP5w5";
export var anim = "block-module--anim--1Auw2";